














































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import VipApi from '@/api/vip/list'
import EmployeeApi from '@/api/employee/index'
@Component
export default class EmployeeDetail extends AbpBase {
  columns: any[] = [
    {
      title: '头像',
      slot: 'headImgUri',
      align: 'center',
    },
    {
      title: '昵称',
      key: 'nickName',
      align: 'center',
    },
    {
      title: '手机号',
      key: 'phoneNumber',
      align: 'center',
    },
    {
      title: '等级',
      key: 'level',
      align: 'center',
    },
    {
      title: '卡号',
      key: 'code',
      align: 'center',
    },
    {
      title: '积分',
      key: 'bonus',
      align: 'center',
    },
    {
      title: '储值',
      key: 'balance',
      align: 'center',
    },
    {
      title: '注册时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '性别',
      key: 'gender',
      align: 'center',
    },
    {
      title: '储值',
      key: 'balance',
      align: 'center',
    },
    {
      title: '标签',
      slot: 'tags',
      align: 'center',
    },
  ]
  tableData: any[] = []
  table: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  columns2: any[] = [
    {
      title: '订单编号',
      slot: 'orderCode',
      align: 'center',
    },
    {
      title: '下单时间',
      slot: 'orderTime',
      align: 'center',
    },
    {
      title: '会员名称',
      key: 'vipName',
      align: 'center',
    },
    {
      title: '会员手机号',
      key: 'vipPhoneNumber',
      align: 'center',
    },
    {
      title: '订单金额',
      key: 'amount',
      align: 'center',
    },
    {
      title: '分佣金额',
      key: 'earningAmount',
      align: 'center',
    },
    {
      title: '订单状态',
      slot: 'orderStatus',
      align: 'center',
    },
  ]
  tableData2: any[] = []
  table2: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 1,
  }

  employeeInfos: any = {}

  created() {
    this.getEmployee()
    this.getVipInfoList()
    this.employeeEarning()
  }

  tagsString(tags) {
    return tags ? tags.join('，') : ''
  }

  /**
   * 获取导购信息
   */
  getEmployee() {
    let id = this.$route.query['id']
    if (id) {
      EmployeeApi.getEmployee(id.toString()).then((res) => {
        this.employeeInfos = res.data
      })
    }
  }

  /**
   * 获取专属会员列表
   */
  getVipInfoList() {
    let id = this.$route.query['id']
    if (id) {
      EmployeeApi.getVipInfoList(id.toString(), this.table.pageSize, this.table.currentPage).then((res) => {
        this.tableData = res.data.items
        this.table.totalCount = res.data.totalCount
      })
    }
  }

  /**
   * 获取指定导购的收益明细
   */
  employeeEarning() {
    let id = this.$route.query['id']
    if (id) {
      EmployeeApi.employeeEarning(id.toString(), this.table.pageSize, this.table.currentPage).then((res) => {
        this.tableData2 = res.data.items
        this.table.totalCount2 = res.data.totalCount
      })
    }
  }

  orderStatusString(state) {
    let text = state
    switch (state) {
      case 0:
        text = '待支付'
        break
      case 1:
        text = '待发货'
        break
      case 2:
        text = '已发货'
        break
      case 3:
        text = '已完成'
        break
      case 4:
        text = '已取消'
        break
    }

    return text
  }

  /**
   * 更改页数
   */
  changePage(e, which) {
    switch (which) {
      case 1:
        this.table.currentPage = e
        this.getVipInfoList()
        break
      case 2:
        this.table2.currentPage = e
        this.employeeEarning()
        break
    }
  }
}
